module.exports = __webpack_public_path__ + "static/media/icon-supplies-babyoil.5315954e.svg";